import { createClient } from '@sanity/client'

export const sanityClient = createClient({
    projectId: "zmpajpdp", // find this at manage.sanity.io or in your sanity.json
    dataset: "production", // t
})